import React, { useEffect, useState } from "react";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import { partnersApi } from "@/lib/api";
import { Star, ShieldCheck } from "lucide-react";

const Partners = () => {
  const [partners, setPartners] = useState([]);
  useEffect(() => { partnersApi.list().then(setPartners).catch(() => {}); }, []);

  return (
    <div className="bg-surface-app min-h-screen text-ink-body">
      <MarketingNav />
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-16 pb-12">
        <div className="text-xs uppercase tracking-[0.28em] text-ink-muted font-mono-accent mb-6">Partner network</div>
        <h1 className="h-display text-5xl md:text-7xl max-w-3xl">
          A vetted local <span className="italic text-artha-amber">co-pilot</span> in every jurisdiction.
        </h1>
        <p className="mt-6 text-lg text-ink-muted max-w-2xl">
          Artha doesn't replace your company secretary — it finds you one. Every partner on our network is vetted, rated, and accountable to strict SLAs.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-artha-light-border border border-border-subtle">
        {partners.map((p) => (
          <div key={p.id} className="bg-surface-card p-8 flex flex-col" data-testid={`partner-card-${p.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">{p.country} · {p.city}</div>
                <h3 className="h-display text-2xl mt-2">{p.name}</h3>
              </div>
              {p.verified && (
                <span className="inline-flex items-center gap-1 text-[10px] font-mono-accent uppercase tracking-[0.18em] text-green-800 bg-green-50 border border-green-200 px-2 py-1">
                  <ShieldCheck size={12} /> Verified
                </span>
              )}
            </div>
            <div className="text-sm text-ink-muted mt-3">{p.specialization}</div>
            <div className="mt-6 pt-4 border-t border-border-subtle grid grid-cols-3 gap-2 text-center">
              <Stat v={<span className="inline-flex items-center gap-1"><Star size={14} className="text-artha-amber fill-artha-amber" />{p.rating}</span>} l="Rating" />
              <Stat v={p.completed} l="Files" />
              <Stat v={`${p.sla_hours}h`} l="SLA" />
            </div>
          </div>
        ))}
      </section>
      <Footer />
    </div>
  );
};

const Stat = ({ v, l }) => (
  <div>
    <div className="font-mono-accent text-base">{v}</div>
    <div className="text-[10px] uppercase tracking-[0.2em] text-ink-muted mt-1">{l}</div>
  </div>
);

export default Partners;
